(() => {
  const THRESHOLD = Number(Theme?.accessWidgetScrollThreshold) || 24;
  const MAX_WAIT = 10000; // 10s safety cap
  const POLL_INTERVAL = 100;

  let ticking = false;
  let isVisible = true;

  function getScrollY() {
    return window.scrollY || window.pageYOffset;
  }

  function showWidget() {
    if (!isVisible && window.accessWidget?.showWidgetInterface) {
      window.accessWidget.showWidgetInterface();
      isVisible = true;
    }
  }

  function hideWidget() {
    if (isVisible && window.accessWidget?.hideWidgetInterface) {
      window.accessWidget.hideWidgetInterface();
      isVisible = false;
    }
  }

  function handleScroll() {
    const scrollY = getScrollY();

    if (scrollY <= THRESHOLD) {
      showWidget();
    } else {
      hideWidget();
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  function waitForAccessWidget() {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const check = () => {
        if (window.accessWidget) {
          return resolve(window.accessWidget);
        }

        if (Date.now() - start >= MAX_WAIT) {
          return reject(new Error("accessWidget not available after timeout"));
        }

        setTimeout(check, POLL_INTERVAL);
      };

      check();
    });
  }

  async function init() {
    try {
      await waitForAccessWidget();

      // Ensure visible on first load
      showWidget();

      window.addEventListener("scroll", onScroll, { passive: true });
    } catch (err) {
      console.warn(err.message);
    }
  }

  // DOM Ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
